// extracted by mini-css-extract-plugin
export default {"wrap":"NH3crqSOtahZLZjIpBY1","body":"HApHMTWro7pvHDcCq7ce","line":"WM4XgH_asP4KVhrPugtX","btns":"C2Hl2SOZMUuVGXcri38g"};